import { authRoles } from "../../auth";
import LoginPage from "./LoginPage";

export const LoginPageConfig = {
  settings: {
    layout: {
      config: {
        header: {
          display: false,
        },
        rightSidebar: {
          display: false,
        },
        footer: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: "/login/:serviceType",
      component: LoginPage,
    },
    {
      path: "/login",
      component: LoginPage,
    },
  ],
};
